import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { useStore } from 'core/store/store.mobx';

import useStyles from './recalculating-dim.styles';

const RecalculatingDim = observer(({ id, className, children, busy = false }) => {
  const { offer: store } = useStore();
  const classes = useStyles();

  const pending = store.recalculatingPrice || busy;

  return (
    <fieldset
      id={id}
      disabled={pending}
      className={classNames(classes.fieldset, className, {
        [classes.recalculatingContent]: pending
      })}
      aria-busy={pending}
    >
      {children}
    </fieldset>
  );
});

RecalculatingDim.propTypes = {
  busy: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default RecalculatingDim;
